import api from '@/helpers/api'

const API_READ = `/api/transaction/`
const API_CREATE = API_READ
const API_OPERATION = `/api/public/transaction`

export default {
    namespaced: true,
    state: {
        status: '',
        transactions: [],
        errMessage: '',
        meta: {
            page: 1,
            limit: 10,
            total: 1
        },
        filter: {},
        search: {},
        sort: {},
        totalData: [],
    },
    mutations: {
        request(state) {
            state.status = 'loading'
        },
        success(state) {
            state.status = 'success'
        },
        error(state, { message }) {
            state.status = 'error'
            state.errMessage = message
        },
        read(state, { transactions }) {
            state.transactions = [...transactions]
        },
        read_single_success(state, { transaction }) {
            state.transaction = transaction
        },
        switch_page(state, { meta }) {
            state.meta = { ...meta }
        },
        add_filter(state, { filter }) {
            state.filter = { ...filter };
        },
        set_search(state, { search }) {
            state.search = { ...search };
        },
        set_sort(state, { sort }) {
            state.sort = { ...sort };
        },
        clear_search(state) {
            state.search = {};
        },
        clear_sort(state) {
            state.sort = {};
        },
        export(state, { transactions }) {
            state.transactions = [...transactions]
        },
        reset_meta(state) {
            state.meta = {
                limit: 10,
                page: 1,
                total: 1,
            }
        },
        totalData(state, { totalData }) {

            state.totalData = totalData;
        },
    },
    actions: {
        read({ commit, state }) {

            commit('request');

            const { meta } = state
            const { filter } = state
            const { search } = state
            const { sort } = state

            return new Promise((resolve, reject) => {
                api.request('get', API_READ, { meta, filter, search, sort })
                    .then((result) => {
                        commit('read', { transactions: result.data.data });
                        commit('switch_page', { meta: { ...result.data.meta } });
                        commit('totalData', { totalData: result.data.meta.totalData });
                        commit('success');
                        return resolve(result);
                    }).catch((err) => {
                        const errorMessage = err.response?.data?.error || err.response?.data?.message || 'Something went wrong';
                        commit('error', { message: errorMessage });
                        return reject(err.response?.data || err);
                    });
            });
        },
        export({ commit, state }) {

            commit('request');

            const { filter } = state
            const { search } = state
            const { sort } = state

            return new Promise((resolve, reject) => {
                api.request('get', `${API_READ}export`, { filter, search, sort }, { responseType: 'blob' })
                    .then((result) => {
                        return resolve(result);
                    }).catch((err) => {
                        const errorMessage = err.response?.data?.error || err.response?.data?.message || 'Something went wrong';
                        return reject({ error: errorMessage });
                    });
            });
        },
        read_single({ commit }, id) {

            commit('request');

            return new Promise((resolve, reject) => {
                api.request('get', `${API_READ}${id}`)
                    .then((result) => {
                        commit('success');
                        return resolve(result.data.data);
                    }).catch((err) => {
                        const errorMessage = err.response?.data?.error || err.response?.data?.message || 'Something went wrong';
                        commit('error', { message: errorMessage });
                        return reject({ error: errorMessage, ...err.response?.data });
                    });
            })
        },
        delete({ commit, dispatch }, { transactionId }) {

            commit('request');

            return new Promise((resolve, reject) => {
                api.request('delete', `${API_READ}${transactionId}`)
                    .then((response) => {
                        dispatch('read');
                        commit('success');
                        return resolve(response.data);
                    }).catch((err) => {
                        const errorMessage = err.response?.data?.error || err.response?.data?.message || 'Something went wrong';
                        commit('error', { message: errorMessage });
                        return reject({ error: errorMessage, ...err.response?.data });
                    });
            })
        },
        create({ commit }, { data }) {

            commit('request')

            return new Promise((resolve, reject) => {
                api.request('post', API_CREATE, {}, data)
                    .then((request) => {
                        commit('success')
                        return resolve(request);
                    }).catch((err) => {
                        const errorMessage = err.response?.data?.error || err.response?.data?.message || 'Something went wrong';
                        commit('error', { message: errorMessage });
                        return reject({ error: errorMessage, ...err.response?.data });
                    });
            })
        },
        update({ commit }, { data }) {

            commit('request');

            return new Promise((resolve, reject) => {
                api.request('patch', API_OPERATION, {}, data)
                    .then((request) => {
                        commit('success');
                        return resolve(request)
                    }).catch((err) => {
                        const errorMessage = err.response?.data?.error || err.response?.data?.message || 'Something went wrong';
                        commit('error', { message: errorMessage });
                        return reject({ error: errorMessage, ...err.response?.data });
                    });
            });
        },
        /**
         * Calculate transaction preview from backend — tax breakdown + point estimate
         * Single source of truth: backend calculates everything from TaxService config
         */
        calculateTransactionPreview(_, { data }) {
            return new Promise((resolve, reject) => {
                api.request('post', `${API_READ}calculate-transaction-preview`, {}, data)
                    .then((result) => {
                        return resolve(result.data.data);
                    }).catch((err) => {
                        const errorMessage = err.response?.data?.error || err.response?.data?.message || 'Failed to calculate preview';
                        return reject({ error: errorMessage });
                    });
            });
        },
        getAvailableVouchers(_, { memberId, params }) {
            return new Promise((resolve, reject) => {
                api.request('get', `/api/member-voucher/${memberId}/available-for-transaction`, params)
                    .then((result) => {
                        return resolve(result.data.data);
                    }).catch((err) => {
                        return reject(err);
                    });
            });
        },
    },
    getters: {
        transactions: () => state => state.transactions,
    }
}
